var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" Overview ")]),_c('server-stats'),_c('server-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }